import React from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { ProgressBar } from 'primereact/progressbar'

import { EInvoiceError, useEInvoiceById } from '../../data'
import { KPIs } from './kpis'
import { Table } from './table'
import { Title } from './title'

export const EInvoiceCockpit: React.FC = () => {
  const location = useLocation()
  const errors = location.state?.errors as EInvoiceError
  const isFirstUpload = location.state?.isFirstUpload as boolean

  const { id } = useParams()

  // If id is "errors", don't try to fetch eInvoice data
  const isErrorsPage = id === 'errors'
  const { data: eInvoice, isLoading } = useEInvoiceById(
    isErrorsPage ? undefined : id,
  )

  const hasErrors = errors?.Results?.some(result => result.Level === 'Error')

  if (!isErrorsPage && isLoading)
    return <ProgressBar mode="indeterminate" style={{ height: '6px' }} />

  return (
    <>
      <Title />
      <div className="grid">
        <KPIs />
        <Table />
      </div>
    </>
  )
}
